import React from 'react';
import { Link } from 'react-router-dom';
import { destinations } from '../../content/siteData';

function Destinations() {
  return (
    <main className="gop-page">
      <section className="gop-page-hero">
        <div className="gop-container">
          <span className="gop-eyebrow">Destinations</span>
          <h1>Explore destination options with better clarity.</h1>
          <p>
            Every country has a different pace, process, and planning style. We help applicants
            compare options more practically before they commit.
          </p>
        </div>
      </section>

      <section className="gop-page-section">
        <div className="gop-container">
          <div className="gop-page-grid">
            {destinations.map((item) => (
              <article key={item.country} className="gop-page-card">
                <strong>{item.country}</strong>
                <h3>{item.focus}</h3>
                <p>{item.detail}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="gop-mini-cta">
        <div className="gop-container gop-mini-cta__inner">
          <div>
            <h2>Need help choosing the right country?</h2>
            <p>We can compare pathways based on budget, profile strength, and long-term goals.</p>
          </div>
          <Link to="/contact" className="gop-btn gop-btn--primary">
            Talk To An Advisor
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Destinations;
